import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  show: false,
  text: "",
  level: 0,
};


export const errorSlice = createSlice({
  name: "error-slice",
  initialState,
  reducers: {
    setToastText:(state, action) => {
      state.show = true;
      state.text = action.payload.text;
      state.level = action.payload.level;
    },
    setShowErrorToast: (state, action) => {
      state.show = action.payload;
    },
  },
});

export const {
  setToastText,
  setShowErrorToast
} = errorSlice.actions;

export default errorSlice.reducer;
